import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register service worker (PWA install-to-home + shell caching). Prod-only to
// avoid conflicts with CRA dev hot reload. Auto-reload when a new SW takes over
// so users immediately see new builds (fixes stale "I don't see the materials
// section" bug after an update).
if ("serviceWorker" in navigator && window.location.protocol === "https:") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then((reg) => {
      if (!reg) return;
      // When an update is found, as soon as the new SW is installed and there
      // is already a controller, activate it immediately.
      reg.addEventListener("updatefound", () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener("statechange", () => {
          if (nw.state === "installed" && navigator.serviceWorker.controller) {
            // New version available – clear caches and reload once.
            if (!sessionStorage.getItem("sw-reloaded")) {
              sessionStorage.setItem("sw-reloaded", "1");
              window.location.reload();
            }
          }
        });
      });
    }).catch(() => {});
    // Fallback: reload when controller changes (new SW claimed clients).
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      if (!sessionStorage.getItem("sw-reloaded")) {
        sessionStorage.setItem("sw-reloaded", "1");
        window.location.reload();
      }
    });
  });
}
